export enum ExportJobStatus {
  INITIATED = 'INITIATED',
  CLAIMED = 'CLAIMED',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
}

export enum ExportKind {
  SHIPPINGS_EXCEL = 'SHIPPINGS_EXCEL',
  ROUTE_VISITS_EXCEL = 'ROUTE_VISITS_EXCEL',
  SHIPPINGS_EXCEL_IMPORT = 'SHIPPINGS_EXCEL_IMPORT',
  EXTERNAL_OPERATOR_SHIPPINGS_EXCEL_IMPORT = 'EXTERNAL_OPERATOR_SHIPPINGS_EXCEL_IMPORT',
  LABELS_PDF_COMBINED = 'LABELS_PDF_COMBINED',
  TRANSIT_CONTROL_EXCEL = 'TRANSIT_CONTROL_EXCEL',
  PICKUPS_EXCEL = 'PICKUPS_EXCEL',
  PICKUP_AUDITS_EXCEL = 'PICKUP_AUDITS_EXCEL',
  CORREO_DELIVERIES_IMPORT = 'CORREO_DELIVERIES_IMPORT',
}

export const EXPORT_KIND_LABELS: Record<ExportKind, string> = {
  [ExportKind.SHIPPINGS_EXCEL]: 'Envíos Excel',
  [ExportKind.ROUTE_VISITS_EXCEL]: 'Visitas de Ruta Excel',
  [ExportKind.SHIPPINGS_EXCEL_IMPORT]: 'Importación de Envíos Excel',
  [ExportKind.EXTERNAL_OPERATOR_SHIPPINGS_EXCEL_IMPORT]: 'Importación de Envíos Excel',
  [ExportKind.LABELS_PDF_COMBINED]: 'Etiquetas PDF combinadas',
  [ExportKind.TRANSIT_CONTROL_EXCEL]: 'Control de Tránsito Excel',
  [ExportKind.PICKUPS_EXCEL]: 'Retiros Excel',
  [ExportKind.PICKUP_AUDITS_EXCEL]: 'Auditoría Pickup',
  [ExportKind.CORREO_DELIVERIES_IMPORT]: 'Entregas del Correo',
};

export const EXPORT_JOB_STATUS_LABELS: Record<ExportJobStatus, string> = {
  [ExportJobStatus.INITIATED]: 'Iniciado',
  [ExportJobStatus.CLAIMED]: 'Procesando',
  [ExportJobStatus.COMPLETED]: 'Completado',
  [ExportJobStatus.ERRORED]: 'Error',
};

export interface ExportJobListItem {
  jobId: string;
  exportKind: ExportKind;
  status: ExportJobStatus;
  fileName: string;
  filterPayload: Record<string, unknown> | null;
  errorMessage: string | null;
  rowCount: number | null;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  durationMs: number | null;
}

export interface ExportJobListResponse {
  count: number;
  rows: ExportJobListItem[];
}

export interface ExportJobDetail extends ExportJobListItem {
  s3Key: string;
  downloadUrl: string | null;
}

export interface ExportJobsFilters {
  status?: ExportJobStatus | '';
  exportKind?: ExportKind | '';
  createdAtFrom?: string;
  createdAtTo?: string;
}
